import { css } from 'styled-components';
import { addsMask } from '../../utils/color-manipulation.js';
import 'react';

const focus = (props) => css `
  box-shadow: 0 0 0 2px ${props.theme.colors.content[props.color]};
  padding: 5px 2px;
  margin: -5px -2px;
  border-radius: 6px;
  outline: transparent solid 2px;
`;
const hover = (props) => css `
  color: ${addsMask({ color: props.color, props })};
`;
const InlineStyles = (props) => css `
  color: ${props.theme.colors.content[props.color]};
  cursor: pointer;
  display: inline;
  font-family: ${props.theme.fontFamilies.main.medium};
  -webkit-font-smoothing: antialiased;
  text-decoration: underline;

  &:focus {
    ${focus}
  }

  &:hover {
    ${hover}
  }
`;

export { InlineStyles };
